import axios from "axios";

const state = {
  userPreferences: null,
  existingFullNames: [],
};

const getters = {
  userPreferences(state) { return state.userPreferences },
  existingFullNames(state) { return state.existingFullNames },
};

const actions = {
  getUserPrefs({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + 'preferences/user')
    .then(response => {
      commit('SET_USER_PREFS', response.data);
    })
  },
  getNames({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + 'preferences/get_names')
      .then(response => {
        commit('SET_EXISTING_FULL_NAMES', response.data)
      })
  },
  updateUserPref({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_API_URL + 'preferences/update_user_pref', data)
        .then(response => {
          resolve(response);
        },error => {
          reject(error);
        })
    })
  },
  updatePrefsFirstLogIn({ commit }, data) {
    axios.post(process.env.VUE_APP_API_URL + 'preferences/update_preferences_first_log_in', data)
    .then(response => {
      commit('SET_USER', response.data.data.user)
      location.reload();
    })
  }
};

const mutations = {
  SET_EXISTING_FULL_NAMES(state, data) { state.existingFullNames = data },
  SET_USER_PREFS(state, data) { state.userPreferences = data },
};


export default {
  state,
  getters,
  actions,
  mutations,
}
